export default {
    path: '/publicPage/primaryAccountNumber',
    name: 'primaryAccountNumber',
    component: () => import(/* webpackChunkName: "common" */ './primaryAccountNumber.vue'),
    meta: {
        authPass: true,
        title: '初级货主页面',
        noTitle: true,
        headerId: 'myFortune'
    }
}